import { FC, ReactNode, createContext, useMemo, useState } from "react";

type PushMonthlyState =
  | { status: "closed" }
  | { status: "open"; oneTimeAmountCents: number; monthlyAmountCents: number };

interface PushMonthlyContextValue {
  state: PushMonthlyState;
  setState: (state: PushMonthlyState) => void;
}

const defaultValue: PushMonthlyContextValue = {
  state: { status: "closed" },
  setState: () => {
    /* no-op default; real implementation is provided by PushMonthlyProvider */
  },
};

export const PushMonthlyContext = createContext<PushMonthlyContextValue>(defaultValue);
PushMonthlyContext.displayName = "PushMonthlyContext";

interface PushMonthlyProviderProps {
  children: ReactNode;
}

export const PushMonthlyProvider: FC<PushMonthlyProviderProps> = ({ children }) => {
  const [state, setState] = useState<PushMonthlyState>({ status: "closed" });

  const value = useMemo<PushMonthlyContextValue>(() => ({ state, setState }), [state]);

  return <PushMonthlyContext.Provider value={value}>{children}</PushMonthlyContext.Provider>;
};

export type { PushMonthlyState };
